import React from 'react';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import classNames from 'classnames';
import type { Theme } from '@material-ui/core';
import { Hidden, Icon, IconButton } from '@material-ui/core';
import { Link } from '@klp/design';
import { AppRoutes } from '@klpkonsern/routing';
import { KlpFontVariant } from '@klp/design/Theme/KlpFontVariant';
import { Logo } from '@klp/design/Logo';
import { useLayoutContext } from '@klp/layout/Layout/LayoutContext';
import { Close } from '@material-ui/icons';

const styles = (theme: Theme) => ({
    drawerLogo: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: theme.header.height,
        padding: 0,
        zIndex: 1201,
        backgroundColor: theme.palette.secondary.dark,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        transition: 'width 0.25s cubic-bezier(0.67, 0, 0.33, 1)',
        boxShadow: theme.shadows[1],
    },
    drawerLogoOpen: {
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: `calc(${theme.sidebar.open.width}px - ${theme.spacing(0)}px)`,
        },
        '& .Sidebar__Menu--pin': {
            opacity: 1,
            transition: 'opacity 0.25s cubic-bezier(0.67, 0, 0.33, 1) 0.25s',
            position: 'relative',
            right: 0,
        },
    },
    logo: {
        fill: theme.palette.background.paper,
        transition: 'fill 0.25s linear, height 0.25s linear',
        width: '52px',
        '&:before': {
            display: 'none',
        },
        '& svg': {
            width: '52px',
            height: 'auto',
        },
    },

    pin: {
        '& .MuiIcon-root': {
            fontSize: KlpFontVariant.default.fontSize,
            color: theme.palette.background.paper,
        },
        transition: 'border-color 0.25s linear, background-color 0.25s linear',
        border: '1px solid',
        borderColor: theme.palette.secondary.dark,
        right: 0,
        opacity: 0,
        backgroundColor: theme.palette.secondary.dark,
        position: 'absolute',
        '&:hover': {
            borderColor: theme.palette.primary.medium,
            backgroundColor: theme.palette.secondary.main,
            '& .MuiIcon-root': {
                color: theme.palette.primary.dark,
            },
        },
    },
    close: {
        color: theme.palette.background.paper,
    },
});
export const SidebarTitle = () => {
    const classes = useKlpStyles({}, styles);

    const { menuOpen, menuPin, setMenuPin, setMenuOpen } = useLayoutContext();

    const toggleMenuPin = () => {
        setMenuPin(!menuPin);
    };

    const handleDrawerClose = () => {
        setMenuOpen(false);
    };

    return (
        <div
            className={classNames(classes.drawerLogo, {
                [classes.drawerLogoOpen]: menuOpen,
            })}
        >
            <Link
                className={classNames(classes.logo)}
                href={AppRoutes.mainPage()}
            >
                <Logo />
            </Link>
            <Hidden xsDown={true}>
                <IconButton
                    className={classNames('Sidebar__Menu--pin', classes.pin)}
                    onClick={toggleMenuPin}
                >
                    {/* eslint-disable-next-line i18next/no-literal-string */}
                    <Icon>push_pin</Icon>
                </IconButton>
            </Hidden>

            <Hidden smUp={true}>
                <IconButton
                    className="Sidebar__Menu--close"
                    onClick={handleDrawerClose}
                >
                    <Close className={classes.close} />
                </IconButton>
            </Hidden>
        </div>
    );
};
